import { ISelection } from 'widgets/Roulette/types';

export enum ACTIONS {
  PLACE_BET = 'PLACE_BET',

  REFRESH_BETS = 'REFRESH_BETS',
  MAKE_BET_AREA_BET = 'MAKE_BET_AREA_BET',
  MAKE_RACE_TRACK_BET = 'MAKE_RACE_TRACK_BET',
  MAKE_STRAIGHT_BET = 'MAKE_STRAIGHT_BET',

  SET_SELECTION = 'SET_SELECTION',
  SET_SELECTION_ON_RACE_TRACK = 'SET_SELECTION_ON_RACE_TRACK',
  SET_RACE_TRACK_SELECTION = 'SET_RACE_TRACK_SELECTION',

  INCREMENT_NEIGHBORS = 'INCREMENT_NEIGHBORS',
  DECREMENT_NEIGHBORS = 'DECREMENT_NEIGHBORS',

  CANCEL_LAST_BET = 'CANCEL_LAST_BET',
  CANCEL_ALL_BETS = 'CANCEL_ALL_BETS',

  CHANGE_MODE = 'CHANGE_MODE',

  SAVE_WINNER_TO_STORE = 'SAVE_WINNER_TO_STORE',

  ADD_CONFIRMED_BET = 'ADD_CONFIRMED_BET',
  SET_CONFIRMED_BET = 'SET_CONFIRMED_BET',

  CLEAR_ALL_BETS = 'CLEAR_ALL_BETS',
}

export interface ISelectionPayload {
  bets: ISelection[];
}
